module.exports = __webpack_public_path__ + "img/pictoPresentation3.a525fd3a.svg";